import { FC, memo } from 'react'

import { EventRemindLabelProps } from './EventRemindLabelProps'
import { getEventRemindLabel } from './getEventRemindLabel'

export const EventRemindLabel: FC<EventRemindLabelProps> = memo(({ name }) => <span>{getEventRemindLabel(name)}</span>)
